import Model from 'models/Model';
import MediaFile from '../mediaFile/Model.MediaFile';
import ProviderStatementBalanceEmailTemplate from '../providerStatementBalanceEmailTemplate/Model.ProviderStatementBalanceEmailTemplate';

export default class ProviderStatementBalanceEmailTemplateAttachment
  extends Model<Model.IProviderStatementBalanceEmailTemplateAttachment>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProviderStatementBalanceEmailTemplateAttachment>
{
  id: number;
  languageIsoCode: Locale.Languages;
  providerStatementBalanceEmailTemplate: ProviderStatementBalanceEmailTemplate;
  providerStatementBalanceEmailTemplateId: number;
  mediaFile: MediaFile;
  mediaFileId: number;

  constructor(
    data:
      | Partial<Model.IProviderStatementBalanceEmailTemplateAttachment>
      | Utils.FormData<Model.IProviderStatementBalanceEmailTemplateAttachment>,
    language?: Locale.Languages
  ) {
    super(
      {
        providerStatementBalanceEmailTemplate: ProviderStatementBalanceEmailTemplate,
        mediaFile: MediaFile,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }
}
